<template>
    <div class="card not-word-wrap mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-12">



                    <form v-on:submit.prevent="submit">

                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>
                                        کد فیدا
                                    </label>
                                    <input class="form-control" v-model="name">
                                </div>
                            </div>
                            <div class="col-md-3 mt-1">
                                <button class="btn btn-success px-4 py-2 mt-4 mx-auto text-center">
                                    استعلام
                                </button>
                            </div>
                        </div>
                    </form>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
 
export default {
    name: 'Update',
    data() {
        return {
            name: "",

        }
    },
    methods: {
        getData() {
        }
    },

    created() {
        this.getData();
    }
}
</script>
